import { useCallback } from 'react';
import { KeywordTableState } from '../../../components/muiLegacy/Tables/KeywordTable/logic/useKeywordTableState';
import { projectsApiService } from '../../../graphql/projects/projectsApiService';
import { useGlobalLoading } from '../../../logic/loadingContext/useGlobalLoading';

export function useBulkTagKeywords(keywordTableState: KeywordTableState, reload: () => Promise<any>) {
  const globalLoading = useGlobalLoading();
  const applyTagMutation = projectsApiService.mutations.tags.useBulkTagKeywords();
  return useCallback(
    (tagGroupId: number, tagId: number) => {
      // Don't proceed unless the user has actively selected keywords
      if (
        !keywordTableState.selectionState.invertSelection &&
        !Object.values(keywordTableState.selectionState.keywordIds).length
      ) {
        return Promise.resolve();
      }

      const loadingKey = 'tagging-tagId' + tagId;
      globalLoading.setLoading(loadingKey, true);

      return applyTagMutation({
        tagId,
        tagGroupId,
        keywordQuery: {
          filtering: keywordTableState.backendFilterState,
          selecting: keywordTableState.backendSelectionState,
        }
      })
        .then(reload)
        .then(keywordTableState.handleResetSelection)
        .finally(() => globalLoading.setLoading(loadingKey, false));
    },
    [keywordTableState.selectionState, keywordTableState.backendFilterState, reload]
  );
}
